import { computed } from "mobx";
import { Modules } from "config";
import type { interfaces } from "inversify";
import type { Action } from "entities/bankExport";
import type TransferType from "entities/transferType";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import SecurityService from "services/securityService";
import BankExportRepository from "repositories/bankExportRepository";
import { bound } from "@frui.ts/helpers";
import { watchBusy } from "@frui.ts/screens";
import ListViewModel from "../../listViewModel";

export default class BankExportDetailListViewModel extends ListViewModel<Action> {
  readonly modelName = "bankExport";

  constructor(
    protected actions: any,
    protected repository: BankExportRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected securityService: SecurityService
  ) {
    super();
  }

  @bound
  @watchBusy
  async loadData() {
    const result = await this.fetchData();
    this.setData([this.processData(result), { limit: result.length, offset: 0, totalItems: result.length }]);
  }

  @computed
  get allowDelete() {
    return false;
  }

  protected fetchData() {
    return this.actions;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `bankExports.${code}`, size);
  }

  translateState(state: TransferType) {
    return this.localizationService.translateEnum("transferType", state);
  }

  static Factory({ container }: interfaces.Context) {
    return (actions: any) => {
      return new BankExportDetailListViewModel(
        actions,
        container.get(BankExportRepository),
        container.get(LocalizationService),
        container.get(EventBus),
        container.get(SecurityService)
      );
    };
  }
}
